/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Account_Notifications_ThresholdInputs */

const he_account_notifications_threshold = /** @type {(inputs: Account_Notifications_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מתחת ל-₪${i?.price}`)
};

const en_account_notifications_threshold = /** @type {(inputs: Account_Notifications_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Below ₪${i?.price}`)
};

/**
* | output |
* | --- |
* | "Below ₪{price}" |
*
* @param {Account_Notifications_ThresholdInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_threshold = /** @type {((inputs: Account_Notifications_ThresholdInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_ThresholdInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_threshold(inputs)
	return en_account_notifications_threshold(inputs)
});